export default __webpack_public_path__ + "static/ideas-88f76e5caaf71f12d9a66c51ea52e776.svg";